<template>
  <div class="d-flex flex-wrap">
    <div
      v-for="(option, index) of info.extension_info.values"
      :key="option"
      class="col-3 m-2"
    >
      <CFormCheck
        :name="`${info.type}-${info.part_item_id}`"
        :id="`${info.type}-${info.part_item_id}-${index}`"
        :disabled="+info.is_help"
        :label="option"
        :value="option"
        @change="emitContent($event, option)"
        required
        :checked="answerList && answerList?.indexOf(index) !== -1"
      />
    </div>
    <div v-if="info.extension_info.last === '其他'" class="col-3 m-2">
      <CFormCheck
        :name="`${info.type}-${info.part_item_id}`"
        :id="`${info.type}-${info.part_item_id}-${info.extension_info.length}`"
        :disabled="+info.is_help"
        label="其他"
        :value="-1"
        @change="emitContent($event, -1)"
        required
        :checked="answerList && answerList?.indexOf(-1) !== -1"
      />
      <CFormInput
        class="col-12 mt-2"
        :disabled="(answerList.indexOf(-1) === -1)"
        placeholder="請填寫其他內容"
        v-model="otherText"
        @blur="emitContent"
      />
    </div>
  </div>
</template>
<script>
import { ref, watch, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const answerList = ref([])
    const optionId = ref(null)
    const otherText = ref('')
    const addOrRemove = (value) => {
      if (answerList.value === '') {
        answerList.value = []
      }
      if (String(value)) {
        const index = answerList.value.indexOf(value)
        if (index === -1) {
          answerList.value.push(value)
        } else {
          answerList.value.splice(index, 1)
        }
      }
    }
    const emitContent = (e, item) => {
      if (item !== undefined) {
        const id = props.info.extension_info.values.findIndex(
          (option) => option === item,
        )
        addOrRemove(item === -1 ? -1 : id)
      }
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: !!answerList.value?.length,
        value_info: +props.info.is_help === 0 ? {
          select: answerList.value,
          other_value: otherText.value,
        } : null,
      })
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newVal) => {
        if(newVal){
          answerList.value = newVal.select
          otherText.value = newVal.other_value
          emitContent(newVal.select)
        }
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
      {immediate: true, deep: true}
    )
    return {
      emitContent,
      addOrRemove,
      optionId,
      answerList,
      otherText,
    }
  },
}
</script>
